import { useEffect } from "react";

// sdx-button / sdx-input hardcode the Swisscom theme in their shadow DOM.
// Injects the same GreenOne overrides as the registration form (SignUp.js)
// into every SDX button/input inside the referenced container.
const BUTTON_STYLES = `
  button,
  button.primary {
    background: #005654 !important;
    border-color: #005654 !important;
    color: #fff !important;
  }

  button:hover,
  button.primary:hover {
    background: #026F6D !important;
    border-color: #026F6D !important;
    color: #fff !important;
  }

  button:focus-visible,
  button.primary:focus-visible {
    outline: 3px solid #005654 !important;
    outline-offset: 2px !important;
  }

  :host([theme="secondary"]) button {
    background: #fff !important;
    color: #005654 !important;
  }

  :host([theme="secondary"]) button:hover {
    background: #eef5f4 !important;
    color: #005654 !important;
  }
`;

const INPUT_STYLES = `
  input:focus,
  input:focus-visible {
    border-color: #026F6D !important;
    outline-color: #026F6D !important;
    box-shadow: 0 0 0 1px #026F6D !important;
  }

  :host(:focus-within) input {
    border-color: #026F6D !important;
    outline-color: #026F6D !important;
    box-shadow: 0 0 0 1px #026F6D !important;
  }
`;

const STYLE_MARKER = "data-greenone-sdx-styles";

function injectStyles(element, css) {
  const shadowRoot = element.shadowRoot;
  if (!shadowRoot || shadowRoot.querySelector(`[${STYLE_MARKER}]`)) return;

  const style = document.createElement("style");
  style.setAttribute(STYLE_MARKER, "true");
  style.textContent = css;
  shadowRoot.appendChild(style);
}

export default function useGreenOneSdxStyles(containerRef) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    function applyStyles() {
      container
        .querySelectorAll("sdx-button")
        .forEach((button) => injectStyles(button, BUTTON_STYLES));
      container
        .querySelectorAll("sdx-input")
        .forEach((input) => injectStyles(input, INPUT_STYLES));
    }

    applyStyles();

    // Shadow roots attach after the SDX components hydrate, and the
    // success view swaps elements, so re-apply on DOM changes.
    const observer = new MutationObserver(applyStyles);
    observer.observe(container, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [containerRef]);
}
